// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace FilterModel {
  export class Service {
    name: string;
    total: number;
  }

  export class ServiceCategory {
    name: string;
    total: number;
    serviceTotals: Service[];
  }

  export class ProfileTotal {
    total: number;
    affiliatedProvider: number;
    easyClaim: number;
    telehealth: number;
    serviceCategoryTotals: ServiceCategory[];
  }

  export class ProfileTotals {
    peopleTotals: ProfileTotal;
    placesTotals: ProfileTotal;
    combinedTotals: ProfileTotal;
  }
}
